import React, {useEffect, useState} from 'react'
import Dialog from './index'
import {getWindowHeight} from '../utils'

interface DialogProps {
  children: any
  maxHeight? : number
  footer?: any
  offset?: number
  title?: string
  onClose?: () => void
}

export function FluidDialog ({children, footer, maxHeight, offset= 80, ...props}: DialogProps) {

  const windowHeight =  getWindowHeight()
  const [height, setHeight] = useState(maxHeight ? Math.min(maxHeight,windowHeight) : windowHeight)

  useEffect(()=>{
    document.body.classList.add('stop-scrolling')
    function handleResize() {
      const wHeight = getWindowHeight();
      const newHeight = maxHeight ? Math.min(maxHeight,wHeight) : wHeight
      setHeight(newHeight)
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
      // supporto per le finestre fluide multiple
      if(document.querySelectorAll(".fluid-dialog-container").length <= 1){
        document.body.classList.remove('stop-scrolling')
      }
    }
  },[maxHeight])

  return (
    <Dialog {...props}>
      <div className={"fluid-dialog-container"} style={{maxHeight: height - offset, overflowY: 'auto'}}>
        {children}
      </div>
      {footer}
    </Dialog>
  )
}
